module.exports = __webpack_public_path__ + "static/img/42.1eb19c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/42.png
// module id = DZru
// module chunks = 0